import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'medsurf-quiz-question-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './question-header.component.html',
    styleUrls: ['./question-header.component.scss'],
    standalone: false
})
export class QuestionHeaderComponent {
  /**
   * Inputs
   */
  @Input() public index: string | null = null;
  @Input() public checkedAndCorrect: boolean;
  @Input() public questionType: string;

  /**
   * Constructor
   *
   * @param translate
   */
  public constructor(public translate: TranslateService) {
  }
}
